import { SHIPPING_STATUS_TYPE } from 'app/utils/constants/status.constants'

export const getBeginCheckoutEventParams = (orders: CheckoutOrderModel[]) => {
  const items = orders.flatMap((order) =>
    order.cart_listings.map((listing) => ({
      item_id: String(listing.listing_id),
      item_name: listing.title,
      price: listing.item_price,
      quantity: listing.item_quantity ?? 1
    }))
  )

  const totalPrice = orders.reduce((acc, order) => acc + order.total_price, 0)

  return {
    ecommerce: {
      currency: 'GBP',
      value: totalPrice,
      items
    }
  }
}

export const getAddShippingInfoEventParams = (order: CheckoutOrderModel) => {
  const items = order.cart_listings.map((listing) => ({
    item_id: String(listing.listing_id),
    item_name: listing.title,
    price: listing.item_price,
    quantity: listing.item_quantity ?? 1
  }))

  const isShipOnly = order?.shipping_type === SHIPPING_STATUS_TYPE.ship_only
  const carrierName = order?.carrier_name ?? 'Ship Only'
  const shippingTier = isShipOnly ? carrierName : 'Click & Collect'

  return {
    ecommerce: {
      currency: 'GBP',
      value: order.total_price,
      shipping_tier: shippingTier,
      items
    }
  }
}

export const getPurchaseEventParams = (order: CheckoutOrderModel) => {
  const items = order.cart_listings.map((listing) => ({
    item_id: String(listing.listing_id),
    item_name: listing.title,
    price: listing.item_price,
    quantity: listing.item_quantity ?? 1
  }))

  const affiliation = order.seller?.store_name || order.seller?.contact_name
  const transactionId = `ORDER_${order.id}`

  return {
    ecommerce: {
      currency: 'GBP',
      value: order.total_price,
      transaction_id: transactionId,
      affiliation,
      tax: 0,
      shipping: order?.rate_price ?? 0,
      items
    }
  }
}

export const getViewItemEventParams = (listing: ListingModel) => {
  const price = listing.actual_price ?? 0

  const items = [
    {
      item_id: String(listing.id),
      item_name: listing.title,
      price,
      quantity: 1
    }
  ]

  return { ecommerce: { currency: 'GBP', value: price, items } }
}

interface GetAddToCartEventProps {
  listingId: string
  listingTitle: string
  actualPrice?: number
  cartQuantity: string | number
}

export const getAddToCartEventParams = ({
  listingId,
  listingTitle,
  cartQuantity,
  actualPrice
}: GetAddToCartEventProps) => {
  const quantity = Number(cartQuantity)
  const totalPrice = !!actualPrice ? actualPrice * quantity : 0

  return {
    ecommerce: {
      currency: 'GBP',
      value: totalPrice ?? 0,
      items: [
        {
          item_id: String(listingId),
          item_name: listingTitle,
          price: actualPrice ?? 0,
          quantity
        }
      ]
    }
  }
}

export const getFirebaseEventParams = (eventParams) => {
  const isEcommerce = 'ecommerce' in eventParams

  if (isEcommerce) {
    const { ecommerce, ...otherParams } = eventParams

    return { ...ecommerce, ...otherParams }
  }

  return eventParams
}
